import StorageIntegrationCardList from '../../AllIntegrations/StorageIntegrationCardList';

function Provider() {
  return <StorageIntegrationCardList isCentered={true} />;
}

export default Provider;
